import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";

const go = (hash) => (e) => {
  e.preventDefault();
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Nav({ onLaunch }) {
  return (
    <header className="fixed top-0 inset-x-0 z-40">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="mt-4 flex items-center justify-between gap-4 rounded-2xl border border-line bg-ink/70 backdrop-blur-xl px-4 md:px-6 py-3">
          <Logo />
          <nav className="hidden md:flex items-center gap-8 font-mono text-[11px] uppercase tracking-[0.2em] text-mid">
            <a href="#watches" onClick={go("#watches")} className="hover:text-hi transition-colors">The watchlist</a>
            <a href="#maths" onClick={go("#maths")} className="hover:text-hi transition-colors">The maths</a>
            <a href="#reminders" onClick={go("#reminders")} className="hover:text-hi transition-colors">Reminders</a>
          </nav>
          <Button
            data-testid="nav-launch-button"
            onClick={onLaunch}
            className="rounded-full bg-ember text-ink font-bold hover:bg-ember/90 font-display text-base uppercase tracking-wider px-5"
          >
            Launch Command
          </Button>
        </div>
      </div>
    </header>
  );
}
